import {
  CallsListItemCellStyles,
  CallsListItemStyle,
} from '~/pages/Calls/componentStyles/CallsListItem.style'
import {
  CallsTableStyle,
  TableHeaderCellStyle,
} from '~/pages/Calls/componentStyles/CallsTable.style'

export const callsComponentStyles = {
  components: {
    CallsTableStyle,
    CallsListItemStyle,
    TableHeaderCellStyle,
    ...CallsListItemCellStyles,
  },
}
